import React from 'react';
import Layout from '../../components/Layout';
import Page from '../../components/Page';
import PageTopbar from '../../components/Page/PageTopbar';
import Faktabank from './Faktabank';
import faktabank from './faktabank.md';

const title = 'Faktabank';

function action(context) {
  let defaultOpen = '';

  if (context.hash) {
    defaultOpen = context.hash.substring(1);
  }

  return {
    chunks: ['faktabank'],
    title: 'Faktabank – Kostrådsguiden',
    component: (
      <Layout>
        <PageTopbar title={title} />
        <Page
          title={title}
          lead={`
            Faktabanken innehåller fördjupad information för att ge dig ett bra
            underlag när du bedömer om den produkt och det kostråd du tänkt
            kombinera är lämpliga att använda.
          `}
          {...faktabank}
        />
        <Faktabank title={title} open={defaultOpen} />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/faktabank/index.js